/** This function formats errors to have a new line for each stack trace */
const formatErrorDetails = (err: unknown): string => {
    if (err instanceof Error) {
        const stackPart = err.stack ? '\n' + err.stack : '';
        return err.name + ': ' + err.message + stackPart;
    }
    try {
        return JSON.stringify(err, null, 2);
    } catch {
        return String(err);
    }
};

export { formatErrorDetails };
